import React from 'react';
import { Step } from '../../types/create';
import { Check } from 'lucide-react';

interface StepIndicatorProps {
  steps: Step[];
}

const StepIndicator: React.FC<StepIndicatorProps> = ({ steps }) => {
  const currentStepNumber = steps.find(step => step.active)?.number || 1;

  return (
    <div className="flex items-center">
      {steps.map((step, index) => {
        const isCompleted = step.number < currentStepNumber;

        return (
          <div key={step.number} className="flex items-center">
            <div className={`
              w-6 h-6 rounded-full flex items-center justify-center text-xs font-medium
              ${step.active
                ? 'bg-blue-600 text-white'
                : isCompleted
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-200 text-gray-600'
              }
            `}>
              {isCompleted ? <Check className="size-3 sm:size-4" /> : step.number}
            </div>
            <span className={`
              ml-2 text-xs font-medium
              ${step.active ? 'text-blue-600' : 'text-gray-500'}
            `}>
              {step.name}
            </span>
            {index < steps.length - 1 && (
              <div className="w-8 h-px bg-gray-300 ml-6" />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default StepIndicator;
